/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TenantConfigurationRequestDTO, UpdateTenantSettingsDto } from '../models/TenantConfigurationRequestDTO';
import type {
  TenantConfigurationResponseDTO,
  TenantSettingsResponseDto,
  UpdateTenantSettingsResponseDto,
  SigningConfigurationRequestDTO,
} from "../models/TenantConfigurationResponseDTO";
import { request as __request } from '@openapi/request';
import { GetESignConfigResponseDto } from '@openapi/services/efna-esign/api/models/GetESignConfigResponseDto'
export class TenantConfigService {

    /**
     * @returns TenantConfigurationResponseDTO Retrieve the data of Tenant Configuration
     * @throws ApiError
     */
    public static async retrieveTenantConfigList(): Promise<TenantConfigurationResponseDTO> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/tenant/tenant-config/list`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TenantConfigurationResponseDTO Update the data of Tenant Configuration
     * @throws ApiError
     */
    public static async updateTenantInformation(
        requestBody: TenantConfigurationRequestDTO,
    ): Promise<TenantConfigurationResponseDTO> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/tenant/tenant-config/update-tenant-config`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UpdateTenantSettingsResponseDto
     * @throws ApiError
     */
    public static async updateTenantSettings(
        requestBody: UpdateTenantSettingsDto,
    ): Promise<UpdateTenantSettingsResponseDto> {
        const result = await __request({
            method: 'PUT',
            path: `/web/api/tenant/tenant-config/update-tenant-settings`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns TenantSettingsResponseDto
     * @throws ApiError
     */
    public static async retrieveTenantSettings(): Promise<TenantSettingsResponseDto> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/tenant/tenant-config/tenant-settings-list`
        });
        return result.body;
    }

    /**
     * @returns GetESignConfigResponseDto Retrieve the data of Signing Configuration
     * @throws ApiError
     */
    public static async retrieveSigningConfigList(): Promise<GetESignConfigResponseDto > {
        const result = await __request({
            method: "GET",
            path: `/web/api/efna/esign/config`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UpdateTenantSettingsResponseDto Update the data of Signing Configuration
     * @throws ApiError
     */
    public static async updateSigningInformation(
        requestBody: SigningConfigurationRequestDTO,
    ): Promise<UpdateTenantSettingsResponseDto > {
        const result = await __request({
            method: "PUT",
            path: `/web/api/efna/esign/config`,
            body: requestBody,
        });
        return result.body;
    }
}